/* global axios */
import ApiClient from '../ApiClient';

class PilotPendingFaqs extends ApiClient {
  constructor() {
    super('pilot/pending_faqs', { accountScoped: true });
  }

  get({ page = 1, search, sort, status } = {}) {
    const params = { page };
    if (search) params.search = search;
    if (sort) params.sort = sort;
    if (status) params.status = status;
    return axios.get(this.url, { params });
  }

  filter(page = 1, sortAttr = 'created_at', queryPayload, search, status) {
    let requestURL = `${this.url}/filter?page=${page}`;
    if (sortAttr) {
      requestURL += `&sort=${sortAttr}`;
    }
    if (search) {
      requestURL += `&search=${encodeURIComponent(search)}`;
    }
    if (status) {
      requestURL += `&status=${status}`;
    }
    return axios.post(requestURL, queryPayload);
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  approve(id, knowledgeBaseId, faqId = null) {
    const payload = { knowledge_base_id: knowledgeBaseId };
    if (faqId) {
      payload.faq_id = faqId;
    }
    return axios.post(`${this.url}/${id}/approve`, payload);
  }

  reject(id, note = '') {
    return axios.post(`${this.url}/${id}/reject`, { note });
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  // 批量操作
  batchApprove(ids, knowledgeBaseId) {
    return axios.post(`${this.url}/batch_approve`, {
      ids,
      knowledge_base_id: knowledgeBaseId,
    });
  }

  batchReject(ids, note = '') {
    return axios.post(`${this.url}/batch_reject`, { ids, note });
  }

  batchDestroy(ids) {
    return axios.post(`${this.url}/batch_destroy`, { ids });
  }

  // 重置操作
  resetToPending(id) {
    return axios.post(`${this.url}/${id}/reset_to_pending`);
  }

  resetToRejected(id, note = '') {
    return axios.post(`${this.url}/${id}/reset_to_rejected`, { note });
  }

  batchResetToPending(ids) {
    return axios.post(`${this.url}/batch_reset_to_pending`, { ids });
  }

  batchResetToRejected(ids, note = '') {
    return axios.post(`${this.url}/batch_reset_to_rejected`, { ids, note });
  }

  // 从已拒绝状态重置
  resetPendingFromRejected(id) {
    return axios.post(`${this.url}/${id}/reset_pending_from_rejected`);
  }

  resetApprovedFromRejected(id, knowledgeBaseId) {
    return axios.post(`${this.url}/${id}/reset_approved_from_rejected`, {
      knowledge_base_id: knowledgeBaseId,
    });
  }

  batchResetPendingFromRejected(ids) {
    return axios.post(`${this.url}/batch_reset_pending_from_rejected`, { ids });
  }

  batchResetApprovedFromRejected(ids, knowledgeBaseId) {
    return axios.post(`${this.url}/batch_reset_approved_from_rejected`, {
      ids,
      knowledge_base_id: knowledgeBaseId,
    });
  }
}

export default new PilotPendingFaqs();
